export const getCurrentCategorySkusFromSticksMatrix = (packagingPreference, orderFrequency, data) => {
    return data ? data[packagingPreference][orderFrequency].map((item) => item.sku) : [];
};
//# sourceMappingURL=getCurrentCategorySkusFromSticksMatrix.js.map